import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { CoreConfigService } from "@core/services/config.service";
import { CoreTranslationService } from "@core/services/translation.service";
import { User } from "app/auth/models";
import { AuthenticationService } from "app/auth/service";
import { locale as english } from "../../../i18n/en";
import { locale as french } from "../../../i18n/fr";
import { locale as german } from "../../../i18n/de";
import { locale as portuguese } from "../../../i18n/pt";
import { locale as italian } from "../../../i18n/it";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { UtilsService } from "../../../auth/service/utils.service";
import { ToastrService } from "ngx-toastr";
import moment from "moment";

@Component({
  selector: "app-dashboard-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MainComponent implements OnInit {
  // Public
  public data: any;

  public currentUser: User;

  public isAdmin: boolean;

  public isEmployee: boolean;

  public isMenuToggled = false;

  //Preset for the column_1 if we don't have anything in the localStorage
  public column_1: any = ["app_summary_absences", "app_my_tasks", "app_absences_to_work", "app_widget_last_candidate", "app_last_requests", "app_cost_standby"];

  //Preset for the column_2 if we don't have anything in the localStorage
  public column_2: any = ["app_my_tickets", "app_my_documents", "app_support_request_assigned_to_me", "app_widget_last_bargaining", "app_last_proposed_candidate"];

  //Preset for the column_3 if we don't have anything in the localStorage

  public column_3: any = ["app_report_unlock_status", "app_my_refunds", "app_my_assets", "app_widget_future_employees", "app_resigned_future_employees", "app_simulation_costs"];

  //Preset for the order in the columns for the widgets, default order must be set to zero
  public order: any = {
    app_summary_absences: 0,
    app_my_tasks: 0,
    app_widget_last_candidate: 0,
    app_last_requests: 0,
    app_my_tickets: 0,
    app_support_request_assigned_to_me: 0,
    app_widget_last_bargaining: 0,
    app_last_proposed_candidate: 0,
    app_report_unlock_status: 0,
    app_my_refunds: 0,
    app_my_assets: 0,
    app_widget_future_employees: 0,
    app_resigned_future_employees: 0,
    app_absences_to_work: 0,
    app_my_documents: 0,
    app_cost_standby: 0,
    app_simulation_costs: 0,
  };

  widgets = [
    "app_summary_absences",
    "app_my_tasks",
    "app_my_documents",
    "app_widget_last_candidate",
    "app_last_requests",
    "app_my_tickets",
    "app_support_request_assigned_to_me",
    "app_widget_last_bargaining",
    "app_last_proposed_candidate",
    "app_report_unlock_status",
    "app_my_refunds",
    "app_my_assets",
    "app_widget_future_employees",
    "app_resigned_future_employees",
    "app_absences_to_work",
    "app_cost_standby",
    "app_simulation_costs",
  ];

  public availableYears: any = [];
  public selectedYear: string = moment().format("YYYY");
  public availableMonths: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  public months: any[] = [];
  public totalWorkingDaysInAYear: number = 0;

  /**
   * Constructor
   * @param {AuthenticationService} _authenticationService
   * @param {CoreConfigService} _coreConfigService
   * @param {CoreTranslationService} _coreTranslationService
   * @param _utilsService
   * @param _changeDetectorRef
   * @param toastr
   */
  constructor(
    public _authenticationService: AuthenticationService,
    private _coreConfigService: CoreConfigService,
    private _coreTranslationService: CoreTranslationService,
    public _utilsService: UtilsService,
    public _changeDetectorRef: ChangeDetectorRef,
    public toastr: ToastrService,
  ) {
    this._authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
    this.isAdmin = this._authenticationService.isAdmin;
    this.isEmployee = this._authenticationService.isEmployee;

    this._coreTranslationService.translate(english, french, german, portuguese, italian);
  }

  /*
   * EN: BEST PRATICES TO ADD A NEW WIDGET
   * 1)Add the component widget in the html file for each column that we have(div that contains the attribute cdkDropList)
   * 2)Add the name of the component in one of the above variable called column_1 column_2 column_3 ecc. (es. app_my_refunds) USE THE UNDERSCORE
   * 3)Add the same name of the component(app_my_refunds) as a key in the object called order and put a zero value
   * IT: BEST PRATICES PER AGGIUNGERE UN NUOVO WIDGET
   * 1)Aggiungi il componente nel html in ogni colonna presente(div che ha come attributo cdkDropList)
   * 2)Aggiungi il nome del componente nelle variabili globali chiamate column_1 ecc. (es. app_my_refunds) usando al posto dei trattini gli underscore
   * 3)Aggiungi il nome del componente (es. app_my_refunds) come chiave nell'oggetto globale chiamato order e settalo come valore a zero
   **/
  ngOnInit() {
    // get the currentUser details from localStorage
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    //Get the column_1 widget from localStorage
    const isInLocalStorageColumn1 = localStorage.getItem("column_1");
    if (isInLocalStorageColumn1) {
      this.column_1 = JSON.parse(isInLocalStorageColumn1);
    }
    //Get the column_2 widget from localStorage
    const isInLocalStorageColumn2 = localStorage.getItem("column_2");
    if (isInLocalStorageColumn2) {
      this.column_2 = JSON.parse(isInLocalStorageColumn2);
    }
    //Get the column_3 widget from localStorage
    const isInLocalStorageColumn3 = localStorage.getItem("column_3");
    if (isInLocalStorageColumn3) {
      this.column_3 = JSON.parse(isInLocalStorageColumn3);
    }

    for (let i: number = Number(this.selectedYear) - 1; i <= Number(this.selectedYear) + 1; i++) {
      this.availableYears.push(String(i));
    }
    //Call the function that order the widgets
    this.orderWidget();
    this.calcuteYearWorkingDays();
  }

  //Funzione che ordina i widget all'interno della colonna //Function that order the widgets in the column
  orderWidget() {
    /*Cicliamo le chiavi dell'oggetto order per settare l'ordine nel div prendendo la index della chiave all'interno
     * delle colonne se sono presenti e andremo poi a settarle all'interno del localStorage */
    Object.keys(this.order).map((key) => {
      this.order[key] = this.column_1.includes(key) ? this.column_1.findIndex((el) => el === key) : this.column_2.includes(key) ? this.column_2.findIndex((el) => el === key) : this.column_3.findIndex((el) => el === key);
    });
    //Settiamo l'ordine nel localStorage
    localStorage.setItem("orderWidget", JSON.stringify(this.order));
  }

  /**
   * After View Init
   */
  ngAfterViewInit() {
    // Subscribe to core config changes
    this._coreConfigService.getConfig().subscribe((config) => {
      // If Menu Collapsed Changes
      if ((config.layout.menu.collapsed === true || config.layout.menu.collapsed === false) && localStorage.getItem("currentUser")) {
        setTimeout(() => {
          if (this._authenticationService.isAdmin) {
            // Get Dynamic Width for Charts
            this.isMenuToggled = true;
          }
        }, 500);
      }
    });
  }

  drop(event: CdkDragDrop<any[]>) {
    //Check if the widget is the last element in the array of the column we'll throw an error
    const fromColumn = event.previousContainer.element.nativeElement.id;
    switch (fromColumn) {
      case "column_1":
        if (this.column_1.length === 1) {
          this.toastrError();
          return false;
        }
        break;
      case "column_2":
        if (this.column_2.length === 1) {
          this.toastrError();
          return false;
        }
        break;
      case "column_3":
        if (this.column_3.length === 1) {
          this.toastrError();
          return false;
        }

        break;
    }
    //End check last element in the array

    //Controls in which array the widget are gonna landing
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      //Funzione che ordina i widget all'interno della colonna //Function that order the widgets in the column
      this.orderWidget();
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      //Funzione che ordina i widget all'interno della colonna //Function that order the widgets in the column
      this.orderWidget();
    }
    /*Dopo aver rilasciato il widget in una colonna lo settiamo nel localStorage
        After dropped a widget in the column, we're gonna set in the local storage*/
    localStorage.setItem("column_1", JSON.stringify(this.column_1));
    localStorage.setItem("column_2", JSON.stringify(this.column_2));
    localStorage.setItem("column_3", JSON.stringify(this.column_3));
  }

  toastrError() {
    this.toastr.error(italian.data.ALERT.ERROR_LAST_WIDGET_IN_THE_ARRAY, italian.data.ALERT.ALERT_TITLE, {
      toastClass: "toast ngx-toastr",
      closeButton: true,
    });
  }

  formatMonth(month: any, format: string = "MMMM") {
    const date: moment.Moment = moment();
    date.set("month", month);
    return date.format(format);
  }

  calcuteYearWorkingDays() {
    this.months = [];
    this.totalWorkingDaysInAYear = 0;
    this.availableMonths.map((month: number) => {
      const obj = {
        name: this.formatMonth(month),
        workingDays: this.calculateWorkingDaysInAMonth(this.selectedYear, String(month + 1).padStart(2, "0")),
      };
      this.months.push(obj);
    });
    this.calculateTotalYearWorkingDays();
  }

  calculateTotalYearWorkingDays() {
    if (this.months && this.months.length > 0) {
      this.months.map((item) => {
        this.totalWorkingDaysInAYear += Number(item.workingDays);
      });
    }
  }

  calculateWorkingDaysInAMonth(year: string, month: string) {
    const date: any = moment(`${year}-${month}-01`).endOf("month");
    if (!!date && date.isValid()) {
      const agencyWorkingDays = this._utilsService.themeConfiguration.working_days; //Oggetto contente giorni lavorativi settimanali
      let start: number = 1;
      let end: number = Number(date.format("DD"));
      let totalWorkingDays: number = 0;

      //Calcolo riferimento delle ore lavorative del mese e anno selezionati
      for (let i = start; i <= end; i++) {
        const currentDate: any = moment(`${year}-${month.padStart(2, "0")}-${i}T22:00:00.000Z`, "YYYY-MM-D");
        const wokingDay: number = agencyWorkingDays.includes(Number(currentDate.format("d"))) ? 1 : 0;

        totalWorkingDays += this._utilsService.isHoliday(currentDate) ? 0 : wokingDay;
      }
      return totalWorkingDays;
    }
  }
}
